import { useEffect, useState, createContext } from 'react';
import * as apiService from "../apiService/apiService"
import { Comment } from '../interfaces/comment';
interface IAllCommentsContext {
  rootComments: Array<Comment>,
  allComments: Array<Comment>,
  getAllComments: Function,
  commentsLoaded:boolean,
  addComment: Function,
  updateComment: Function,
  removeComment: Function,
  getReplies: Function
}
const initialValue: IAllCommentsContext = {
  rootComments: [],
  allComments: [],
  commentsLoaded:true,
  getAllComments: () => { },
  addComment: () => { },
  updateComment: () => { },
  removeComment: () => { },
  getReplies: () => { }
}
export const AllCommentsContext = createContext<IAllCommentsContext>(initialValue);
export const AllCommentsContextProvider = ({ children }: any): JSX.Element => {
  const [allComments, setallComents] = useState<Array<Comment>>([]);
  const [commentsLoaded, setCommentsLoaded] = useState(false);
  const rootComments = allComments.filter((comment) => comment.parentId === null);
  const getReplies = (id: number) => {
    return allComments.filter((comment) => comment.parentId === id).sort((a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime());
  }
  useEffect(() => {
    getAllComments();
  }, [])
  const getAllComments = async () => {
    try {
      setCommentsLoaded(false);
      const res = await apiService.getCommentsApi();
      setallComents(res);
      setCommentsLoaded(true);
    } catch (error) {
    }
  }
  const addComment = async (email: string, comment: string, parentId: number) => {
    try {
      await apiService.addCommentApi(email, comment, parentId);
      getAllComments();
    } catch (error) {

    }
  }
  const updateComment = async (id: number, email: string, comment: string) => {
    try {
      await apiService.updateCommentApi(id, email, comment)
      getAllComments();
    } catch (error) {

    }
  }
  const removeComment = async (id: string) => {
    try {
      await apiService.removeCommentApi(id);
      getAllComments();
    } catch (error) {

    }
  }
  return (
    <AllCommentsContext.Provider value={{ allComments, getAllComments, addComment, updateComment, removeComment, rootComments, getReplies,commentsLoaded }}>
      {children}
    </AllCommentsContext.Provider>
  );
}